const MARC_BIBLIOGRAPHIC = {
  name: 'marcBib',
  recordType: 'MARC_BIBLIOGRAPHIC',
};

export default MARC_BIBLIOGRAPHIC;
